import type { ReactNode } from "react";
import { cx } from "../cx";
import { Badge } from "../primitives/Badge";
import { Mono } from "../primitives/Text";
/**
 * Fila de traza: el método citado, las keywords que casaron, su capa y los
 * puntos. El probador de enrutado las trae todas; la traza guardada de un
 * turno solo trae el método y su `titulo` curado — lo que no se guardó no se
 * dibuja, así que todo salvo `slug` es opcional (el hueco de las keywords se
 * mantiene para que la fila conserve su geometría).
 */
export function TraceRow({ slug, keywords, titulo, capa, score, win }: { slug: ReactNode; keywords?: readonly string[] | undefined; titulo?: ReactNode | undefined; capa?: ReactNode | undefined; score?: number | undefined; win?: boolean | undefined }) {
  return (
    <div className={cx("sk-trace", win && "sk-win", score === 0 && "sk-zero")}>
      <Mono>{slug}</Mono>
      <span style={{ display: "flex", gap: "var(--sk-sp-1)", flexWrap: "wrap", flex: 1 }}>
        {keywords === undefined ? null : keywords.length ? keywords.map((k) => <span className="sk-kw" key={k}>{k}</span>) : <span className="sk-kw sk-fainted">—</span>}
      </span>
      {titulo !== undefined && <Badge>{titulo}</Badge>}
      {capa !== undefined && <Badge>{capa}</Badge>}
      {score !== undefined && <span className="sk-num" style={{ marginLeft: "auto" }}>{score} pt</span>}
    </div>
  );
}
